<template>
	<div class="w-fit h-fit min-w-46 rounded-xl border border-neutral-subtle border-solid bg-neutral p-8 card-shadow">
		<div class="flex items-center">
			<span v-if="title" class="flex-grow text-xl font-bold leading-[28px] text-heading">{{ title }}</span>
			<span v-if="showVisibilityToggle" class="clickable-text" @click.prevent="showContents = !showContents">{{ showContents ? 'Hide' : 'Show' }}</span>
		</div>

		<div v-show="showContents" class="w-full">
			<slot></slot>
		</div>
	</div>
</template>

<script setup lang="js">
import { ref } from 'vue'

defineProps({
	title: { type: String, default: null },
	showVisibilityToggle: { type: Boolean, default: false }
})

const showContents = ref(true)

</script>

<style scoped>

.card-shadow {
	box-shadow: 0 8px 13px -3px rgba(0, 0, 0, 0.07);
}

</style>
